
var current_variant_image_url;
var current_variant_price;
var current_variant_title;

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let c of cookies) {
    const [key, value] = c.split("=");
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

document.querySelectorAll(".btn-contact").forEach((btn_contact) => {
  btn_contact.addEventListener('click', () => {
    //document.getElementById("popupOverlay").style.display = "flex";
    current_variant_title = btn_contact.getAttribute('data-product-title');
    setCookie("ProductTitle", current_variant_title, 0.1);
    window.location.href = "/pages/contact";
  });
});

document.querySelectorAll(".btn-add-to-cart").forEach((btn_add_to_cart) => {
  btn_add_to_cart.addEventListener('click', () => {
    current_variant_id = btn_add_to_cart.getAttribute('data-product-id');
    //document.getElementById("popupOverlay").style.display = "flex";
    current_variant_image_url = btn_add_to_cart.getAttribute('data-product-image-url');
    current_variant_price = btn_add_to_cart.getAttribute('data-product-price');
    current_variant_title = btn_add_to_cart.getAttribute('data-product-title');
    setCookie("ProductImage", current_variant_image_url, 0.1);
    setCookie("ProductPrice", current_variant_price, 0.1);   
    setCookie("ProductTitle", current_variant_title, 0.1);
    window.location.href = "/pages/order-submit";
  });
});

document.querySelectorAll(".btn-terms").forEach((btn_term) => {
  btn_term.addEventListener('click', () => {
    current_variant_id = btn_term.getAttribute('data-product-id');
    //document.getElementById("popupOverlay").style.display = "flex";
    current_variant_title = btn_term.getAttribute('data-product-title');
    setCookie("ProductTitle", current_variant_title, 0.1);
    window.location.href = "/pages/order-submit";
  });
});

document.querySelectorAll(".btn-buy-now").forEach((btn_buy_now) => {
    btn_buy_now.addEventListener('click', () => {
        current_variant_image_url = btn_buy_now.getAttribute('data-product-image-url');
        current_variant_price = btn_buy_now.getAttribute('data-product-price');
        current_variant_title = btn_buy_now.getAttribute('data-product-title');
        setCookie("ProductImage", current_variant_image_url, 0.1);
        setCookie("ProductPrice", current_variant_price, 0.1);
        setCookie("ProductTitle", current_variant_title, 0.1);
        //document.getElementById("popupOverlay").style.display = "flex";
        //document.querySelector(".term_cond_container").classList.add("reserve");
        window.location.href = "/pages/order-submit"
    });
});

document.querySelectorAll(".order_submit_button").forEach((order_submit_button) => {
    order_submit_button.addEventListener('submit', (e) => {
        e.preventDefault();

    });
});

console.log(document.cookie);

if (document.querySelector("#contact-ContactFormProduct")){
    document.querySelector("#contact-ContactFormProduct").value = getCookie("ProductTitle");
    setCookie("ProductTitle", '', 0.1);
}
if (document.querySelector("#contact-ContactFormPrice")){
    document.querySelector("#contact-ContactFormPrice").value = getCookie("ProductPrice");
    setCookie("ProductPrice", '', 0.1);
}
if (document.querySelector(".order_image")){
    document.querySelector(".order_image").src = getCookie("ProductImage");
}
if (document.querySelector(".order_title")){
    document.querySelector(".order_title").innerHTML = '</a>' + getCookie("ProductTitle") + '</a>';
}
if (document.querySelector(".order_price")){
    document.querySelector(".order_price").innerHTML = getCookie("ProductPrice");
}
